import { Modal } from "react-bootstrap";

const SelectSequenceTypeModal = ({ show, onClose, onSelectType }) => {
  return (
    <Modal show={show} onHide={onClose} centered size="lg" keyboard={false}>
      <Modal.Header closeButton className="custom-modal-header">
        <Modal.Title>Select a Sequence Type</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between custom-modal-body">
          <div
            className="sequence-type-box w-50 me-4"
            onClick={() => onSelectType("Survey")}
            style={{
              cursor: "pointer",
              padding: "20px",
              textAlign: "center",
              borderRadius: "5px",
              boxShadow: "2px 2px 2px 3px rgba(0, 0, 0, 0.1)",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="105"
              height="120"
              viewBox="0 0 105 120"
              fill="none"
              style={{ marginBottom: "10px" }}
            >
              <path
                d="M93.75 22.5C93.75 20.4375 92.0625 18.75 90 18.75H15C12.9375 18.75 11.25 20.4375 11.25 22.5V97.5C11.25 99.5625 12.9375 101.25 15 101.25H90C92.0625 101.25 93.75 99.5625 93.75 97.5V22.5ZM90 7.5C98.2734 7.5 105 14.2266 105 22.5V97.5C105 105.773 98.2734 112.5 90 112.5H15C6.72656 112.5 0 105.773 0 97.5V22.5C0 14.2266 6.72656 7.5 15 7.5H90ZM60 37.5C60 40.6172 57.4922 43.125 54.375 43.125H28.125C25.0078 43.125 22.5 40.6172 22.5 37.5C22.5 34.3828 25.0078 31.875 28.125 31.875H54.375C57.4922 31.875 60 34.3828 60 37.5ZM76.875 54.375C79.9922 54.375 82.5 56.8828 82.5 60C82.5 63.1172 79.9922 65.625 76.875 65.625H28.125C25.0078 65.625 22.5 63.1172 22.5 60C22.5 56.8828 25.0078 54.375 28.125 54.375H76.875ZM45 82.5C45 85.6172 42.4922 88.125 39.375 88.125H28.125C25.0078 88.125 22.5 85.6172 22.5 82.5C22.5 79.3828 25.0078 76.875 28.125 76.875H39.375C42.4922 76.875 45 79.3828 45 82.5Z"
                fill="url(#paint0_linear_25735_629)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_25735_629"
                  x1="17.026"
                  y1="9.85899"
                  x2="121.156"
                  y2="115.368"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#53C6F2" />
                  <stop offset="0.505208" stopColor="#2F80ED" />
                  <stop offset="1" stopColor="#56CCF2" />
                </linearGradient>
              </defs>
            </svg>
            <div>Survey</div>
          </div>
          <div
            className="sequence-type-box w-50"
            onClick={() => onSelectType("Quiz")}
            style={{
              cursor: "pointer",
              padding: "20px",
              textAlign: "center",
              borderRadius: "5px",
              boxShadow: "2px 2px 2px 3px rgba(0, 0, 0, 0.1)",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="75"
              height="120"
              viewBox="0 0 75 120"
              fill="none"
              style={{ marginBottom: "10px" }}
            >
              <path
                d="M15 37.5C15 27.1407 23.3906 18.75 33.75 18.75H41.25C51.6094 18.75 60 27.1407 60 37.5V38.5782C60 44.2266 57.1875 49.5 52.4766 52.6172L40.2188 60.7969C35.0156 64.2657 31.875 70.125 31.875 76.4063V76.875C31.875 79.9922 34.3828 82.5 37.5 82.5C40.6172 82.5 43.125 79.9922 43.125 76.875V76.4063C43.125 73.8985 44.3672 71.5547 46.4531 70.1719L58.7109 61.9922C66.5391 56.7657 71.2266 48 71.2266 38.6016V37.5235C71.2266 20.9532 57.7969 7.52347 41.2266 7.52347H33.7266C17.1797 7.50003 3.75 20.9297 3.75 37.5C3.75 40.6172 6.25781 43.125 9.375 43.125C12.4922 43.125 15 40.6172 15 37.5ZM37.5 112.5C39.4891 112.5 41.3968 111.71 42.8033 110.303C44.2098 108.897 45 106.989 45 105C45 103.011 44.2098 101.103 42.8033 99.6967C41.3968 98.2902 39.4891 97.5 37.5 97.5C35.5109 97.5 33.6032 98.2902 32.1967 99.6967C30.7902 101.103 30 103.011 30 105C30 106.989 30.7902 108.897 32.1967 110.303C33.6032 111.71 35.5109 112.5 37.5 112.5Z"
                fill="url(#paint0_linear_25735_632)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_25735_632"
                  x1="65.359"
                  y1="98.8074"
                  x2="-7.64696"
                  y2="54.4879"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#F2994A" />
                  <stop offset="1" stopColor="#F2C94C" />
                </linearGradient>
              </defs>
            </svg>
            <div>Quiz</div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SelectSequenceTypeModal;
